import { IKeyboardRow } from '.';

export const standart: Array<IKeyboardRow> = [
  {
    keys: [
      { character: 'ABC', special: 'lang', span: 2 },
      { character: '123', special: 'symbols', keyboard: 'symbols', span: 2 },
      { character: 'Clear', special: 'clear', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'q', span: 1 },
      { character: 'w', span: 1 },
      { character: 'e', span: 1 },
      { character: 'r', span: 1 },
      { character: 't', span: 1 },
      { character: 'y', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'u', span: 1 },
      { character: 'i', span: 1 },
      { character: 'o', span: 1 },
      { character: 'p', span: 1 },
      { character: 'a', span: 1 },
      { character: 's', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'd', span: 1 },
      { character: 'f', span: 1 },
      { character: 'g', span: 1 },
      { character: 'h', span: 1 },
      { character: 'j', span: 1 },
      { character: 'k', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'l', span: 1 },
      { character: 'z', span: 1 },
      { character: 'x', span: 1 },
      { character: 'c', span: 1 },
      { character: 'v', span: 1 },
      { character: 'b', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'n', span: 1 },
      { character: 'm', span: 1 },
      { icon: 'delete', special: 'delete', span: 4 },
    ],
  },
  {
    keys: [{ character: 'SPACE', special: 'space', span: 6 }],
  },
];

export default standart;
